import { useScreenSize } from '@hooks';
import { activitiesSlice } from '@store';
import { Flex, theme, Typography } from '@styles';
import { object, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ActivityModalLayout, ActivityTooltip } from '../ActivityModalLayout';
import { Modal } from '../Modal';
import ActivityButton from './ActivityButton';

const ActivityHeader = ({ activityVariant, containerProps, title }) => {
  const dispatch = useDispatch();
  const { isTabletSM } = useScreenSize();

  const [isModalVisible, setModalVisible] = useState(false);
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const activitiesInfoModal = useSelector(
    (state) => state.activitiesSlice.activitiesInfoModal
  );

  const onActivityHover = (value) => () => {
    setTooltipVisible(value);
  };

  const onActivityClick = () => {
    setModalVisible(true);
  };

  const handleModalClose = () => {
    document.body.style.overflow = 'unset';
    setModalVisible(false);
  };

  useEffect(() => {
    if (
      !isModalVisible &&
      !activitiesInfoModal?.[`${activityVariant}ModalState`]
    ) {
      setModalVisible(true);
      dispatch(
        activitiesSlice.actions.setActivitiesInfoModalState({
          modal: `${activityVariant}ModalState`,
          state: true,
        })
      );
    }
  }, [activityVariant, activitiesInfoModal]);

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      {...containerProps}
    >
      <Modal
        isVisible={isModalVisible}
        modalContainerProps={{
          backgroundColor: theme.colors.white[10],
          border: `1px solid ${theme.colors.white[10]}`,
          borderRadius: '0px',
          height: '100%',
          maxHeight: isTabletSM ? '100%' : '480px',
          maxWidth: '640px',
          width: '100%',
        }}
        setModalVisible={setModalVisible}
        withBackdropNoise
        {...(isTabletSM && { modalMaxHeight: '100%' })}
      >
        <ActivityModalLayout
          onModalClose={handleModalClose}
          variant={activityVariant}
        />
      </Modal>
      <Typography
        color={theme.colors.white[100]}
        variant={isTabletSM ? 'BN-bold-s32-lh28' : 'BN-bold-s43-lh38'}
      >
        {title?.toUpperCase()}
      </Typography>
      <ActivityButton
        onClick={onActivityClick}
        onHover={onActivityHover}
        variant={activityVariant}
      />
      <ActivityTooltip isVisible={isTooltipVisible} variant={activityVariant} />
    </Flex>
  );
};

ActivityHeader.propTypes = {
  activityVariant: string.isRequired,
  containerProps: object,
  title: string.isRequired,
};

ActivityHeader.defaultProps = {
  containerProps: {},
};

export default ActivityHeader;
